import { Skeleton } from "primereact/skeleton"

export type HuAvatarCardSidebarSkeletonProps = {
  topContent?: React.JSX.Element
  className?: string
  style?: React.CSSProperties
} & React.ComponentProps<"div">

export function HuAvatarCardSidebarSkeleton({ topContent, className, style, ...props }: HuAvatarCardSidebarSkeletonProps) {
  const defaultClassName = "relative"
  const defaultStyle = {
    marginTop: "-85px",
    marginLeft: "-20px",
    marginRight: "-20px",
  }

  return (
    <div className={className ?? defaultClassName} style={style ?? defaultStyle}>
      <div className="flex flex-column w-full h-16rem align-items-center justify-content-center bg-neutralColor-50 border-round-bottom-3xl" {...props}>
        {/* TOP CONTENT */}
        {topContent}

        <div className="flex gap-3 justify-content-center align-items-center pt-6 w-full">
          <div className="relative">
            <Skeleton shape="circle" size="6rem" className="mb-1" />
          </div>
          <div className="flex  flex-column justify-content-center align-items-center gap-2 ">
            <Skeleton width="10rem" height="2rem" borderRadius="8px" />
            <Skeleton width="5rem" height="1rem" borderRadius="4px" />
          </div>
        </div>

        <div className="absolute flex flex-column gap-1 right-0 mr-3" style={{ marginTop: "7rem" }}>
          <Skeleton shape="circle" size="2rem" className="p-2" />
          <Skeleton shape="circle" size="2rem" className="p-2" />
        </div>
      </div>
    </div>
  )
}
